<template>
  <div>
    <Header
      title="教师缓考审核"
      type="0"
      route="/teacher/jshksh"
      :casLogin="casLogin"
    ></Header>
    <div class="center">
      <div class="center-list">
        <!-- <div class="paperClip-circle"></div> -->
        <!-- <img class="paperClip" src="../../../../assets/images/paperClip.png" /> -->
        <div class="list-left">
          <div class="left-title">{{ dataObj.kcmc }}({{ dataObj.kch }})</div>
          <div class="left-line">
            <div style="width:40%">
              <span>申请人:</span>
              <span style="margin-left: 5px;">{{ dataObj.sqr }}</span>
            </div>
            <div class="left-line-line">
              <span>学号:</span>
              <span style="margin-left: 5px;">{{ dataObj.xh }}</span>
            </div>
          </div>
          <div class="left-line">
            <div style="width:40%">
              <span>班级:</span>
              <span style="margin-left: 5px;">{{ dataObj.bj }}</span>
            </div>
            <div class="left-line-line">
              <span>院系:</span>
              <span style="margin-left: 5px;">{{ dataObj.yx }}</span>
            </div>
          </div>
          <div class="left-line">
            <div style="width:100%">
              <span>学期:</span>
              <span style="margin-left: 5px;">{{ dataObj.xnxq }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="center-content-white">
        <div class="white-left">成绩录入人</div>
        <div class="white-right">{{ dataObj.jsxm }}</div>
      </div>
      <div class="center-content-white">
        <div class="white-left">申请时间</div>
        <div class="white-right">{{ dataObj.sqsj }}</div>
      </div>
      <div class="center-content-white">
        <div class="white-left">教师审核状态</div>
        <div class="white-right">{{ dataObj.jsshztmc }}</div>
      </div>
      <div class="center-content-white">
        <div class="white-left">最终审核状态</div>
        <div class="white-right">{{ dataObj.zzshztmc }}</div>
      </div>
      <div class="center-content-white" style="align-items: flex-start;">
        <div class="white-left">缓考原因</div>
        <div
          class="white-right"
          style="width: 60%;word-break: break-all;text-align: right"
        >
          {{ dataObj.hkyy }}
        </div>
      </div>
      <!-- <div class="center-content-white" style="align-items: flex-start;">
        <div class="white-left">附件</div>
        <div
          class="white-right"
          style="width: 60%;word-break: break-all;text-align: right"
        >
          <div v-if="dataObj.qzwffilename != ''" id="myMain" @click="reImage2" style="color:#0055FF">
            {{ dataObj.qzwffilename }}
          </div>
          <div v-else >
            无
          </div>
        </div>
      </div> -->
    </div>
    <!-- <van-popup v-model="show" id="reImg" @click="reImage3">
        <img
          :src="img"
          alt=""
          srcset=""
          class="fjimg"
          v-for="(img, index) in imgList"
          :key="index"
        />
    </van-popup> -->
    <div class="bottom">
      <van-button class="bottom-button" v-show="dataObj.jsiswfmes=='2'" type="default" @click="pushExamine"
        >审核</van-button
      >
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      casLogin: sessionStorage.getItem("casLogin"),
      schoolCode: sessionStorage.getItem("schoolCode"),
      show: false,
      back: "",
      dataObj: [],
      imgList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    reImage2() {
      this.show = true;
    },
    reImage3() {
      this.show = false;
    },
    async getList() {
      this.dataObj = JSON.parse(decodeURI(this.$route.params.route_params));
      // if (this.dataObj.fjname != ''){
      //   const ret = await Api.hksqDownfile({
      //     hkid: this.dataObj.cj0704hkid
      //   });
      //   if (ret.code != 0){
      //       this.imgList = ret.data;
      //   }
      // }
    },
    pushExamine() {
      this.$router.push({
        name: "js_jshksh_sh",
        params: {
          route_params: encodeURI(JSON.stringify(this.dataObj))
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fjimg {
  max-width: 320px;
}
.cultivate-content {
    height: 80%;
    overflow: auto;
    padding: 0 20px;
    overflow-x: hidden;
    img {
      margin-left: -20%;
      width: 140%;
    }
  }
.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  background-color: #fff;

  .bottom-button {
    width: calc(~"100% - 40px");
    background-color: @attendance-background-color-1;
    color: white;
    font-size: 16px;
    font-weight: 600;
    height: 44px;
    line-height: 44px;
    border-radius: 3px;
    margin-bottom: 10px;
  }
}
.upload-line {
  /deep/ .van-field__label {
    width: 75px;
  }
}
.center {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 40px;
  .center-list {
    width: calc(~"100% - 80px");
    background: url(../../../../assets/images/card_bg3.png) no-repeat top center;
    background-size: cover;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding: 20px 20px 18px 20px;
    position: relative;
    .paperClip {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 22px;
      height: 22px;
    }
    .paperClip-circle {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 32px;
      height: 32px;
      border-radius: 30px;
      background: @attendance-background-color-16;
    }
    .list-left {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      .left-title {
        width: 100%;
        font-size: 16px;
        color: white;
        font-weight: 600;
        letter-spacing: 1px;
        margin-bottom: 8px;
      }
      .left-line {
        width: 100%;
        font-size: 12px;
        color: rgb(243, 240, 240);
        margin-bottom: 2px;
        display: flex;
      }
    }
  }
  .center-content-white {
    width: calc(~"100% - 60px");
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .white-left {
      color: @attendance-color-2;
      font-size: 14px;
    }
    .white-right {
      color: @attendance-color-2;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .center-content-gray {
    width: calc(~"100% - 60px");
    margin-bottom: 16px;
    padding: 8px 10px 4px 10px;
    display: flex;
    flex-wrap: wrap;
    background-color: @attendance-background-color-10;
    border-radius: 3px;
    .gray-line-one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 4px;
      .gray-left {
        color: @attendance-color-2;
        font-size: 14px;
      }
      .gray-right {
        color: @attendance-background-color-12;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Examine/jshksh/jshkshListDetail.vue